import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, Loader2, UserRound } from "lucide-react";
import { toast } from "sonner";
import { useSignedUrl } from "../../components/admin/MediaCard";
import { supabase } from "../../lib/supabase";

export const CARD_COLS = "share_id,full_name,age,height,highest_qualification,occupation,city,photos,response";

function MatchCard({ m }) {
  const photo = m.photos?.[0]?.storage_path;
  const { url, failed } = useSignedUrl("profile-photos", photo);
  return (
    <Link to={`/portal/matches/${m.share_id}`} data-testid={`match-card-${m.share_id}`} className="rmm-card rmm-rise block overflow-hidden transition-shadow hover:shadow-xl">
      <div className="flex aspect-[4/3] items-center justify-center bg-[#F4EFEA]">
        {!photo || failed ? <UserRound data-testid={`match-photo-placeholder-${m.share_id}`} className="h-12 w-12 text-[#D4AF37]" /> : url ? <img src={url} alt="Profile photo" data-testid={`match-photo-${m.share_id}`} className="h-full w-full object-cover" /> : <Loader2 className="h-5 w-5 animate-spin text-[#7A0016]" />}
      </div>
      <div className="space-y-1 p-4">
        <p data-testid={`match-name-${m.share_id}`} className="font-display text-2xl font-bold text-[#4A000E]">{m.full_name || "Name not provided"}</p>
        <p className="text-sm text-[#2C2424]">{[m.age && `${m.age} yrs`, m.height].filter(Boolean).join(" · ")}</p>
        <p className="text-sm text-[#8C6A6C]">{[m.highest_qualification, m.occupation].filter(Boolean).join(" · ")}</p>
        {m.city && <p className="text-xs text-[#8C6A6C]">{m.city}</p>}
        {m.response === "interested" && <p className="inline-flex items-center gap-1 pt-1 text-xs font-semibold text-emerald-700"><Heart className="h-3 w-3 fill-current" />Interested</p>}
      </div>
    </Link>
  );
}

export default function MyMatches() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    supabase.from("client_shared_profiles").select(CARD_COLS).order("shared_at", { ascending: false })
      .then(({ data, error }) => { if (error) toast.error(error.message); setRows(data || []); });
  }, []);
  if (rows === null) return <Loader2 className="mx-auto h-6 w-6 animate-spin text-[#7A0016]" />;
  if (!rows.length) {
    return <p data-testid="matches-empty" className="rmm-card p-8 text-center text-sm text-[#8C6A6C]">No matches shared yet. Our team will share suitable profiles with you soon.</p>;
  }
  return (
    <div data-testid="my-matches-page" className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {rows.map((m) => <MatchCard key={m.share_id} m={m} />)}
    </div>
  );
}
